import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  loaded: boolean;
  push: MetaPixel;
  queue: unknown[][];
  version: string;
};
type MetaPixelWindow = Window & {
  _fbq?: MetaPixel;
  fbq?: MetaPixel;
};
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { BeforeAfter } from './components/BeforeAfter';
import { SolutionOverview } from './components/SolutionOverview';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    const pixelWindow = window as MetaPixelWindow;
    if (pixelWindow.fbq) {
      pixelWindow.fbq('track', 'PageView');
      return;
    }
    const pixel = ((...args: unknown[]) => {
      if (pixel.callMethod) {
        pixel.callMethod(...args);
        return;
      }
      pixel.queue.push(args);
    }) as MetaPixel;
    pixel.callMethod = undefined;
    pixel.loaded = true;
    pixel.queue = [];
    pixel.push = pixel;
    pixel.version = '2.0';
    pixelWindow.fbq = pixel;
    pixelWindow._fbq = pixel;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    pixel('init', '1329604392388692');
    pixel('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-ink font-sans text-stone-100 selection:bg-accent selection:text-ink" data-id="element-0" data-mp="3dirv2ofh4589">
      <Hero data-id="element-1" data-mp="nxn902b9pls4" />
      <SocialProof data-id="element-2" data-mp="suncq6knacg2" />
      <Testimonials data-id="element-3" data-mp="su43rfcz2ye6" />
      <PainPoints data-id="element-4" data-mp="stkjhrzunxwz" />
      <BeforeAfter data-id="element-5" data-mp="st2k4mhw53ku" />
      <SolutionOverview data-id="element-6" data-mp="swglbretj6qp" />
      <Tomos data-id="element-7" data-mp="3688dot76uy6" />
      <Bonuses data-id="element-8" data-mp="35ox2qy1z4t4" />
      <OfferSection data-id="element-9" data-mp="356sn718lka4" />
      <Guarantee data-id="element-10" data-mp="34nc9ur8j3y7" />
      <FAQ data-id="element-11" data-mp="38b7cycbvyf1" />
      <FinalCTA data-id="element-12" data-mp="3uct0zcywiaxb" />
      <Footer data-id="element-13" data-mp="3udazkg91d18e" />
    </div>;
}